import { Image } from "./image";
import React from "react";

export const Gallery = (props) => {
  const data = props.data;
  const onProjectSelect = props.onProjectSelect;

  return (
    <div id="portfolio" className="text-center">
      <div className="container">
        <div className="section-title">
          <h2>{data ? data.title : "Projects"}</h2>
          <p>{data ? data.subtitle : ""}</p>
        </div>
        <div className="row">
          <div className="portfolio-items">
            {data && data.items
              ? data.items.map((d, i) => (
                  <div
                    key={`${d.title}-${i}`}
                    className="col-sm-6 col-md-4 col-lg-4"
                  >
                    <Image
                      title={d.title}
                      largeImage={d.largeImage}
                      smallImage={d.smallImage}
                      onSelect={onProjectSelect}
                    />
                  </div>
                ))
              : "Loading..."}
          </div>
        </div>
      </div>
    </div>
  );
};
